export { SharedDataAccessErrorModule } from './lib/shared-data-access-error.module';
export { ErrorDataModule } from './lib/error-data/error-data.module';
export { ErrorDataService } from './lib/error-data/error-data.service';
export { Error } from './lib/models/error.model';
